module.exports = {
  'account.footer.copyright': '© 2018 - 2019 Binance.org. Bảo lưu mọi quyền.',
  'account.footer.copyright.trubi': '© 2018 - 2019 Trubi. Bảo lưu mọi quyền.',
  'account.footer.exchange': 'Sàn giao dịch',
  'account.footer.home': 'Trang chủ',
  'balances.filteredByAsset': 'Lọc theo tài sản',
  'balances.hideZeroBalance': 'Ẩn số dư bằng 0',
  'balances.myBalances': 'Số dư của tôi',
  'blocked.country.list':
    'Hoa Kỳ, Albania, Bosnia và Herzegovina, Belarus, Cộng hoà Dân chủ Congo, Bờ Biển Ngà, Crimea, Cuba, Iraq, Iran, Triều Tiên, Liberia, Macedonia, Myanmar, Serbia, Sudan, Syria, Zimbabwe.',
  'common.cancel': 'Hủy bỏ',
  'common.close': 'Đóng',
  'common.confirm': 'Xác nhận ',
  'common.connect': 'Kết nối',
  'common.continue': 'Tiếp tục',
  'common.errorOccured': 'đã xảy ra lỗi',
  'common.goBack': 'Quay lại',
  'common.googleUnlock': 'Google Drive',
  'common.keystoreFile': 'File Keystore',
  'common.ledgerDevice': 'Thiết bị Ledger',
  'common.loading': 'Đang tải',
  'common.mnemonicPhrase': 'Cụm từ khôi phục',
  'common.networkError': 'Lỗi mạng lưới',
  'common.or': 'hoặc',
  'common.password': 'Mật khẩu',
  'common.placeOrder': 'Đặt lệnh',
  'common.pleaseCheckVisitWebsite': 'Hãy đảm bảo rằng bạn đang truy cập ',
  'common.previous': 'Trước',
  'common.privateKey': 'Private Key',
  'common.systemError': 'Lỗi hệ thống',
  'common.trezorDevice': 'Thiết bị Trezor',
  'common.viewMyPrivateKey': 'Xem Private Key của tôi',
  'common.viewOnly': 'Chỉ xem',
  'common.walletConnect': 'Ví di động',
  'common.yes': 'Có',
  'common.warning': 'Warning',
  'create.backupKeystore.backupYour': 'Sao lưu dự phòng của bạn ',
  'create.backupKeystore.cannotRecoveredIt': 'Nó sẽ không thể được khôi phục nếu bạn làm mất.',
  'create.backupKeystore.createBackupFile': 'Hãy tạo bản lưu dự phòng cho file này!',
  'create.backupKeystore.downloadKeystoreFile': 'Tải xuống File Keystore (UTC/JSON)',
  'create.backupKeystore.getMyPrivateKey': 'Lấy Private Key của tôi',
  'create.backupKeystore.keystoreFile': 'File Keystore',
  'create.backupKeystore.needFirstDownload': 'Bạn phải tải xuống file keystore trước',
  'create.backupKeystore.notShareFile':
    'Không được chia sẻ hoặc sử dụng file này trên bất kỳ website chưa được xác minh này. Tài sản của bạn có thể sẽ bị đánh cắp.',
  'create.backupMnemonic.note':
    'Hãy ghi lại đoạn văn bản dưới đây lên giấy và lưu trữ nó ở một nơi bí mật và an toàn.',
  'create.backupMnemonic.title': 'Xin hãy sao lưu lại cụm từ ghi nhớ',
  'create.backupText':
    'Hãy ghi lại đoạn văn bản dưới đây lên giấy và lưu trữ nó ở một nơi bí mật và an toàn.',
  'create.chooseKSOrMnemonic.keystoreAndPassword': 'File Keystore + Mật khẩu',
  'create.chooseKSOrMnemonic.keystoreFile': 'File Keystore',
  'create.chooseKSOrMnemonic.recommendedUSBDrive': 'Khuyến nghị là nên lưu lại trên USB',
  'create.chooseKSOrMnemonic.recommendedUSBDriveOrPaper':
    'Khuyến nghị là nên lưu lại trên giấy hoặc trên USB',
  'create.chooseKSOrMnemonic.title': 'Bạn muốn tạo ví mới theo cách nào?',
  'create.chooseKSOrMnemonic.unlockExistWallet': 'Mở khoá Ví sẵn có',
  'create.chooseKSOrMnemonic.useKeystoreFile':
    'Sử dụng File Keystore (UTC / JSON) + Mật khẩu để truy cập vào ví của bạn',
  'create.chooseKSOrMnemonic.useMnemonicPhrase':
    'Sử dụng Cụm từ Ghi nhớ 24 ký tự để truy cập vào ví',
  'create.confirmNote': 'Bạn có chắc đã ghi lại Cụm từ Ghi nhớ?',
  'create.createNewWallet': 'Tạo ví mới',
  'create.doubleConfirmMnemonic.note':
    'Hãy lựa chọn Cụm từ Ghi nhớ theo đúng thứ tự để chắc rằng bản lưu của bạn là chính xác.',
  'create.doubleConfirmMnemonic.title': 'Chọn cách truy cập phụ',
  'create.doubleConfirmMnemonic.tryAgain':
    'Thứ tự Cụm từ Ghi nhớ không chính xác. Vui lòng thử lại.',
  'create.downloadKeyStoreFile': 'Tải xuống File Keystore',
  'create.enterPassword': 'Nhập mật khẩu',
  'create.google.createWallet': 'Tạo ví',
  'create.google.createdSuccessfully': 'Tạo ví thành công',
  'create.google.creationFailure': 'Tạo ví thất bại',
  'create.google.tryAgain': 'Thử lại',
  'create.google.walletName': 'Tên ví',
  'create.googledrive.rePassErr': 'Mật khẩu đã nhập không khớp',
  'create.keystoreFileAndPassword': 'Tạo File Keystore + Mật khẩu',
  'create.pick.useGoogleDrive.description': 'Tạo ví mới bằng tài khoản Google',
  'create.pick.useGoogleDrive.title': 'Sử dụng Google Drive',
  'create.pick.useLocalKeystore.description': 'Tạo ví mới bạn có thể lưu trong thiết bị của mình',
  'create.pick.useLocalKeystore.title': 'Sử dụng Keystore File',
  'create.pleaseCheck': 'Hãy đảm bảo rằng bạn đang truy cập ',
  'create.reEnterPassword': 'Nhập lại mật khẩu',
  'create.stepTwo.desc':
    'Chúng tôi chuẩn bị hiển thị cụm từ ghi nhớ, hãy bảo đảm không có ai đang nhìn vào màn hình của bạn.',
  'create.success.desc1': 'Bạn đã sẵn sàng sử dụng ví Binance Chain và',
  'create.success.desc2': 'Sàn giao dịch phi tập trung!',
  'create.success.title': 'Bạn đã sẵn sàng!',
  'create.success.unlockWallet': 'Mở khoá ví',
  'create.tutorial.next': 'Tiếp theo',
  'create.tutorial.skip': 'Bỏ qua phần hướng dẫn (không nên)',
  'create.tutorial.step1.desc1':
    'Binance cam kết cung cấp cho bạn trải nghiệm tốt nhất và an toàn nhất trên Binance Chain. Để làm được điều này, chúng tôi yêu cầu bạn dành ra một phút để hiểu cách ví phi tập trung hoạt động và có những biện pháp để tự bảo vệ mình. Bạn có thể đọc Điều khoản Dịch vụ ở đây.',
  'create.tutorial.step1.title': 'Cam kết của chúng tôi',
  'create.tutorial.step2.desc1':
    'Bạn hoàn toàn chịu trách nhiệm bảo quản tiền của mình. Không một ai, kể cả Binance, có thể giúp bạn lấy lại tiền nếu để mất.',
  'create.tutorial.step2.desc2':
    'Khi tạo ví trên Binance, bạn được cung cấp 3 định dạng khác nhau, có thể dùng một trong ba để truy cập vào ví.',
  'create.tutorial.step2.title': 'Giữ tiền của bạn',
  'create.tutorial.step3.desc1':
    'Bạn có thể nghĩ file keystore như là "ID người dùng", còn mật khẩu là để mở khoá ví. Cần cả hai để có thể truy cập ví, nên phải giữ chúng an toàn. Đây là một yêu cầu bắt buộc của Binance.',
  'create.tutorial.step3.title': 'File Keystore + Mật khẩu',
  'create.tutorial.step4.desc1':
    '24 ký tự vừa là "ID người dùng" và mật khẩu. Đây là cách thứ hai để truy cập vào ví trong trường hợp mất file keystore hoặc quên mật khẩu. Bất kỳ ai biết cụm từ ghi nhớ của bạn đều có thể truy cập vào ví, nên hãy giữ nó an toàn.',
  'create.tutorial.step4.title': 'Cụm từ Ghi nhớ',
  'create.tutorial.step5.desc1': 'Đây là một cách hiển thị khác cho cụm từ ghi nhớ.',
  'create.tutorial.step5.desc2':
    'Binance yêu cầu tất cả người dùng sử dụng file keystore + mật khẩu; và chọn hoặc cụm từ ghi nhớ hoặc private key làm phương án dự phòng.',
  'create.tutorial.step5.title': 'Private Key',
  'create.tutorial.title': 'Hướng dẫn tạo ví',
  'create.tutorial.understand': 'Tôi hiểu',
  'create.understandCheckbox':
    'Tôi hiểu là Binance không thể khôi phục hoặc đặt lại mật khẩu hoặc file keystore của tôi. Tôi sẽ tạo một bản sao lưu file keystore/mật khẩu, giữ bí mật nó, hoàn thành tất cả các bước tạo ví và đồng ý với tất cả ',
  'create.understandCheckbox.terms': 'điều khoản',
  'create.unlockExistWallet': 'Mở khoá Ví sẵn có',
  'create.yourKeyStore': 'Keystore của bạn',
  'editWallet.remove': 'Gỡ bỏ',
  'editWallet.remove.desc1': 'Hãy chắc chắn rằng ví hiện không có tiền',
  'editWallet.remove.desc2': 'vì không có cách nào để khôi phục ví',
  'editWallet.remove.removeButton': 'Đúng, gỡ bỏ ví',
  'editWallet.remove.title': 'Bạn có chắc chắn sẽ gỡ bỏ ví này?',
  'editWallet.rename': 'Đổi tên',
  'editWallet.rename.duplicateName': 'Tên ví đã tồn tại',
  'editWallet.rename.errMsg': 'Tên không được bỏ trống',
  'editWallet.rename.title': 'Tên ví',
  'editWallet.title': 'Tên ví',
  'editWallet.createWallet': 'Tạo ví',
  'editWallet.unlockWallet': 'Mở ví',
  'exchange.BTCValue': 'Giá trị BTC',
  'exchange.amount': 'Số lượng',
  'exchange.asset': 'Tài sản',
  'exchange.availableBalance': 'Số dư khả dụng',
  'exchange.blockHeight': 'Độ cao khối',
  'exchange.buy': 'Mua',
  'exchange.calendar.clear': 'Xoá',
  'exchange.calendar.ok': 'Đồng ý',
  'exchange.calendar.today': 'Hôm nay',
  'exchange.chartbox.depth': 'Độ sâu',
  'exchange.coin': 'Đồng coin',
  'exchange.date': 'Ngày',
  'exchange.estimatedValue': 'Giá trị ước tính',
  'exchange.filled': 'Đã khớp lệnh',
  'exchange.from': 'Từ',
  'exchange.frozen': 'Đã đóng băng',
  'exchange.hideAllCanceled': 'Ẩn tất cả lệnh đã huỷ',
  'exchange.hideOtherPairs': 'Ẩn các cặp khác',
  'exchange.inOrder': 'Đang đặt lệnh',
  'exchange.index.books': 'Sổ lệnh',
  'exchange.index.chart': 'Đồ thị',
  'exchange.max': 'Tối đa',
  'exchange.min': 'Số lượng giao dịch tối thiểu:',
  'exchange.name': 'Tên',
  'exchange.notional': 'Danh nghĩa',
  'exchange.oneDay': '1 Ngày',
  'exchange.oneMonth': '1 Tháng',
  'exchange.oneWeek': '1 Tuần',
  'exchange.pair': 'Cặp',
  'exchange.placeOrder.bestAsk': 'Giá hỏi bán tốt nhất',
  'exchange.placeOrder.bestBid': 'Giá hỏi mua tốt nhất',
  'exchange.placeOrder.limitOrder': 'Lệnh Limit',
  'exchange.placeOrder.noEnoughBalance': 'số dư không đủ',
  'exchange.placeOrder.orderError': 'Lỗi đặt lệnh',
  'exchange.placeOrder.orderPriceHigher':
    'Giá đặt lệnh của bạn sẽ cao hơn 2% so với giá thị trường gần nhất. Hãy thao tác thận trọng.',
  'exchange.placeOrder.orderPriceLow':
    'Giá đặt lệnh của bạn sẽ thấp hơn 2% so với giá thị trường gần nhất. Hãy thao tác thận trọng.',
  'exchange.placeOrder.pleaseInputCorrectAmount': 'hãy nhập số lượng chính xác',
  'exchange.placeOrder.pleaseInputCorrectPrice': 'hãy nhập mức giá chính xác',
  'exchange.placeOrder.roundSizeErrorMsg':
    'Bạn chỉ có thể {side}{baseAsset} với số lượng {lotSize}',
  'exchange.placeOrder.successNotifyMsg':
    'Bạn đã tạo thành công lệnh limit {side}{quantity}{quoteAsset}',
  'exchange.placeOrder.successNotifyTitle': 'Đã tạo Lệnh Limit {side}',
  'exchange.pleaseSelectDate': 'vui lòng chọn ngày',
  'exchange.pleaseUnlockWallet.btn': 'Mở khoá ví',
  'exchange.pleaseUnlockWallet.createNewWallet': 'Tạo ví mới',
  'exchange.pleaseUnlockWallet.desc': 'Oops! Vui lòng mở khoá ví trước',
  'exchange.pleaseUnlockWallet.noWallet': 'Không có ví?',
  'exchange.price': 'Giá',
  'exchange.search': 'Tìm kiếm',
  'exchange.sell': 'Bán',
  'exchange.side': 'Bên',
  'exchange.status': 'Trạng thái',
  'exchange.symbolPriceInfo.high': 'Giá cao nhất',
  'exchange.symbolPriceInfo.lastPrice': 'Giá gần nhất',
  'exchange.symbolPriceInfo.low': 'Giá thấp nhất',
  'exchange.symbolPriceInfo.twentyFourHChange': 'Thay đổi 24h',
  'exchange.symbolPriceInfo.twentyFourHHigh': 'Giá cao nhất 24h',
  'exchange.symbolPriceInfo.twentyFourHLow': 'Giá thấp nhất 24h',
  'exchange.symbolPriceInfo.twentyFourHVolume': 'Khối lượng giao dịch 24h',
  'exchange.symbolPriceInfo.vol': 'KL',
  'exchange.threeMonths': 'Quý',
  'exchange.time.from': 'Từ',
  'exchange.to': 'Đến',
  'exchange.total': 'Tổng',
  'exchange.totalBalance': 'Tổng số dư',
  'exchange.tradingHistory.time': 'Thời gian',
  'exchange.tradingHistory.title': 'Lịch sử giao dịch',
  'exchange.tradingPair.change': 'Thay đổi',
  'exchange.tradingPair.pair': 'Cặp',
  'exchange.tradingPair.price': 'Giá',
  'exchange.tradingPair.search': 'Tìm kiếm',
  'exchange.tradingPair.volume': 'Khối lượng',
  'exchange.txFee': 'Phí giao dịch',
  'exchange.txHash': 'Hash giao dịch',
  'exchange.type': 'Loại',
  'exchange.value': 'Giá trị',
  'fees.fee': 'Phí giao dịch',
  'fees.height': 'Độ cao',
  'fees.note': 'Lưu ý',
  'footer.terms': 'Điều khoản Dịch vụ',
  'footer.privacy': 'Privacy',
  'googledrive.create.nameExist': 'Tên tồn tại',
  'header.balances': 'Số dư',
  'header.createWallet': 'Tạo ví mới',
  'header.exchange': 'Sàn giao dịch',
  'header.explorer': 'Explorer',
  'header.faq': 'Docs / FAQ',
  'header.feeHistory': 'Lịch sử phí',
  'header.forums': 'Diễn đàn',
  'header.mainnet': 'Mainnet',
  'header.openOrders': 'Lệnh đang mở',
  'header.orderHistory': 'Lịch sử lệnh',
  'header.orders': 'Lệnh',
  'header.testnet': 'testnet',
  'header.tradeHistory': 'Lịch sử giao dịch',
  'header.transactions': 'Giao dịch',
  'header.unlockWallet': 'Mở khoá ví',
  'header.user.changeWallet': 'Thay đổi ví',
  'header.user.closeWallet': 'Đóng ví',
  'header.user.coinomi': 'Coinomi ',
  'header.user.copyAddress': 'sao chép địa chỉ',
  'header.user.copySuccess': 'Sao chép thành công!',
  'header.user.createNewWallet': 'Tạo ví mới',
  'header.user.exportKeystoreFile': 'Xuất File Keystore',
  'header.user.goToExplorer': 'đi đến explorer',
  'header.user.infinito': 'Infinito ',
  'header.user.ledger': 'Ví Ledger ',
  'header.user.trezor': 'Thiết bị Trezor',
  'header.user.wallet': 'Ví',
  'header.user.walletConnect': 'Ví WalletConnect ',
  'header.youWantCloseWallet': 'Bạn có chắc là muốn đóng ví?',
  'home.aboutPage.desc1.line1':
    'Binance Chain là một sáng kiến blockchain ban đầu được phát triển bởi Binance.',
  'home.aboutPage.desc1.line2':
    'Nó hiện đại, an toàn và có tốc độ giao dịch gần như tức thì (nhanh chóng).',
  'home.aboutPage.desc2.line1': 'Binance DEX là một cơ chế khớp lệnh phi tập trung,',
  'home.aboutPage.desc2.line2': 'cấp nguồn bởi công nghệ Binance Chain.',
  'home.aboutPage.desc3.line1': 'Binance DEX là một thị trường hiện đại và an toàn để phát hành',
  'home.aboutPage.desc3.line2':
    'và giao dịch tài sản kỹ thuật số, và không ai ngoài bạn nắm giữ private key. Việc giao dịch tài sản ưa thích của bạn chưa bao giờ an toàn như lúc này.',
  'home.aboutPage.title': 'Về Binance DEX',
  'home.binanceDex': 'Binance DEX',
  'home.processPage.aboutBalance': 'Về Binance DEX',
  'home.processPage.create': 'Tạo',
  'home.processPage.createDesc': 'Bước đầu tiên là tạo địa chỉ Binance Chain.',
  'home.processPage.createWallet': 'Tạo ví mới',
  'home.processPage.getStart': 'Bắt đầu với Binance DEX',
  'home.processPage.go': 'Đi đến',
  'home.processPage.placeOrders': 'Đặt lệnh',
  'home.processPage.placeOrdersDesc': 'Sử dụng ví trên web hoặc API để gửi hoặc huỷ lệnh.',
  'home.processPage.transferAssets': 'Chuyển tài sản',
  'home.processPage.transferAssetsDesc':
    'Với địa chỉ Binance Chain, vốn được tạo ra cho bất kỳ ví nào hỗ trợ Binance Chain, bạn có thể chuyển BNB hoặc các tài sản khác được lưu trữ ở địa chỉ đó.',
  'home.processPage.unlock': 'Mở khoá',
  'home.processPage.unlockDesc': 'Bốn cách để mở khoá ví của bạn',
  'home.processPage.unlockMode1': 'Ví WalletConnect',
  'home.processPage.unlockMode2': 'Ví Ledger',
  'home.processPage.unlockMode3': 'File Keystore + Mật khẩu',
  'home.processPage.unlockMode4': 'Cụm từ ghi nhớ',
  'home.processPage.unlockWallet': 'Mở khoá ví',
  'home.startPage.createWallet': 'Tạo ví mới',
  'home.startPage.desc1': 'Nền tảng giao dịch tài sản kỹ thuật số nhanh và an toàn',
  'home.startPage.desc2': 'Tiêu chuẩn mới cho giao dịch tiền mã hoá đã có mặt.',
  'home.startPage.getTestBNB': 'Nhận BNB thử nghiệm',
  'home.startPage.startTrading': 'Bắt đầu giao dịch',
  'home.whyPage.community': 'Nó là một Sáng kiến Cộng đồng',
  'home.whyPage.communityDesc':
    'Binance Chain được cấp nguồn bởi cơ chế quản trị on-chain và các phần mềm mã nguồn mở.',
  'home.whyPage.decentralized': 'Phi tập trung',
  'home.whyPage.decentralizedDesc':
    'Trải nghiệm giao dịch trực tiếp giữa các ví mà không thông qua bất kỳ bên thứ ba hoặc cơ chế tập quyền nào.',
  'home.whyPage.getStarted': 'Hãy bắt đầu',
  'home.whyPage.lowTradingFees': 'Phí giao dịch thấp',
  'home.whyPage.lowTradingFeesDesc':
    'Giao dịch mà không có phí nạp, rút hoặc đặt lệnh - và người sở hữu BNB còn nhận được nhiều lợi nhuận hơn.',
  'home.whyPage.safeAndSecure': 'An toàn và Bảo đảm',
  'home.whyPage.safeAndSecureDesc':
    'Tiền của bạn được giữ trên một địa chỉ blockchain với private key chỉ mình bạn kiểm soát.',
  'home.whyPage.title': 'Vì sao lại chọn Binance DEX',
  'home.whyPage.userFriendly': 'Thân thiện với người dùng',
  'home.whyPage.userFriendlyDesc':
    'Tạo ví, mở khoá ví, và bạn đã sẵn sàng giao dịch. Không cần phải nạp hoặc rút.',
  'inputPassword.passwordRule': 'Mật khẩu của bạn phải bao gồm các thành tố sau',
  'inputPassword.passwordRule1': 'Tối thiểu 8 ký tự',
  'inputPassword.passwordRule2': 'Có ký tự in hoa, biểu tượng và số',
  'inputPassword.setANewPassword': 'Đặt mật khẩu mới',
  'landing.connectWallet': 'Kết nối ví',
  'landing.createWallet': 'Tạo ví mới',
  'landing.desc1': 'Binance DEX',
  'landing.desc2':
    'Nền tảng giao dịch tài sản kỹ thuật số nhanh và an toàn. Tiêu chuẩn mới cho giao dịch tiền mã hoá đã có mặt.',
  'landing.footer.fee': 'Phí',
  'landing.footer.terms': 'Điều khoản Dịch vụ',
  'landing.footer.privacy': 'Privacy',
  'landing.how.connect': 'Kết nối',
  'landing.how.connect.desc':
    'Việc truy cập Binance DEX dễ hơn rất nhiều so với bạn nghĩ. Chỉ cần nhấp vào nút kết nối và lựa chọn một trong những lựa chọn kết nối. Và thế là xong.',
  'landing.how.create': 'Tạo',
  'landing.how.create.desc':
    'Binance DEX cho bạn quyền lựa chọn từ keystore tiện lợi cho đến các loại ví phần cứng bảo mật tối đa.',
  'landing.how.step': 'bước',
  'landing.how.title': 'Cách sử dụng',
  'landing.how.trade': 'Giao dịch',
  'landing.how.trade.desc':
    'Mục tiêu của chúng tôi là khiến hoạt động giao dịch liền mạch và không tách biệt khỏi Binance.com. Để làm điều này, chúng tôi đã tối ưu những tính năng tốt nhất để mọi thứ bạn yêu thích đều có trên Binance DEX.',
  'landing.markets': 'Thị trường',
  'landing.markets.24HChange': 'Thay đổi 24H',
  'landing.markets.24HVolume': 'Khối lượng 24H',
  'landing.markets.lastPrice': 'Giá gần nhất',
  'landing.markets.pair': 'Cặp',
  'landing.markets.searchPlaceholder': 'Tìm kiếm đồng coin',
  'landing.menu.balances': 'Số dư',
  'landing.menu.changeWallet': 'Thay đổi ví',
  'landing.menu.closeWallet': 'Đóng ví',
  'landing.menu.community': 'Cộng đồng',
  'landing.menu.copyAddress': 'sao chép địa chỉ',
  'landing.menu.docs': 'Docs',
  'landing.menu.exchange': 'Sàn giao dịch',
  'landing.menu.explorer': 'Khám phá',
  'landing.menu.orders': 'Lệnh',
  'landing.menu.orders.feeHistory': 'Lịch sử phí',
  'landing.menu.orders.openOrders': 'Lệnh đang mở',
  'landing.menu.orders.orderHistory': 'Lịch sử đặt lệnh',
  'landing.menu.orders.tradeHistory': 'Lịch sử giao dịch',
  'landing.menu.testnet': 'Testnet',
  'landing.menu.tools': 'Công cụ',
  'landing.menu.transaction': 'Giao dịch',
  'landing.menu.wallet': 'Ví',
  'landing.startTrading': 'Bắt đầu giao dịch',
  'landing.trust.activeAddress': 'Ví đang hoạt động',
  'landing.trust.activeAddress.desc':
    'Nhiều người tin tưởng cơ sở hạ tầng và hệ thống giao dịch của Binance DEX hơn những giải pháp ví khác.',
  'landing.trust.pairs': 'Cặp',
  'landing.trust.pairs.desc':
    'Binance DEX cho bạn thêm lựa chọn và sự linh hoạt trong giao dịch, mỗi tuần một tính năng mới.',
  'landing.trust.rank': 'Xếp hạng',
  'landing.trust.rank.desc':
    'Binance DEX là sàn giao dịch tiền mã hoá phi tập trung có khối lượng giao dịch lớn nhất trên CoinMarketCap.',
  'landing.trust.title': 'Vì sao người dùng tin tưởng chúng tôi',
  'landing.why.competitive': 'Cạnh tranh',
  'landing.why.competitive.desc':
    'Phí giao dịch chỉ là 0.04% khi bạn dùng BNB để trả phí. Con số này thấp gần một nửa so với Binance.com, sàn giao dịch có mức phí phải chăng hàng đầu thế giới.',
  'landing.why.fast': 'Nhanh chóng',
  'landing.why.fast.desc':
    'Với thời gian tạo khối 1 giây, xác nhận giao dịch blockchain giờ đã là quá khứ. Hãy tận dụng tất cả lợi thế của DEX mà không lo gián đoạn giao dịch.',
  'landing.why.secure': 'An toàn',
  'landing.why.secure.desc':
    'Binance DEX đưa công tác bảo mật lên một tầm cao mới. Chuyển tiền và giao dịch đồng cấp giúp hạn chế tối đa các hiểm hoạ an ninh.',
  'landing.why.title': 'Vì sao lại chọn Binance DEX',
  'lang.menu.copyAddress': ' ',
  'noContent.descPrefix': 'Bạn không có ',
  'openOrders.areYourTrue': 'Bạn có chắc là muốn',
  'openOrders.cancel': 'huỷ',
  'openOrders.cancel all': 'huỷ tất cả',
  'openOrders.cancel buy': 'huỷ mua',
  'openOrders.cancel sell': 'huỷ bán',
  'openOrders.cancelAll': 'Huỷ Tất cả',
  'openOrders.cancelBuy': 'Huỷ Mua',
  'openOrders.cancelOrder': 'Huỷ lệnh',
  'openOrders.cancelOrders': 'Huỷ các lệnh',
  'openOrders.cancelPartialSuccess': 'Huỷ một phần thành công',
  'openOrders.cancelSell': 'Huỷ lệnh bán',
  'openOrders.cancelSuccess': 'Huỷ thành công',
  'openOrders.keepOrder': 'Giữ lệnh',
  'openOrders.keepOrders': 'Giữ các lệnh',
  'openOrders.noBuyOpenOrders': 'không có lệnh mua nào đang mở',
  'openOrders.noOpenOrders': 'không có lệnh nào đang mở',
  'openOrders.noSellOpenOrders': 'không có lệnh bán nào đang mở',
  'openOrders.title': 'Lệnh đang mở',
  'orderForm.amount': 'Số lượng',
  'orderForm.avb': 'Avb',
  'orderForm.buy': 'Mua',
  'orderForm.equivalent': 'Tương đương',
  'orderForm.price': 'Giá',
  'orderForm.sell': 'Bán',
  'orderForm.total': 'Tổng',
  'orderHistory.openHistory': 'lịch sử đặt lệnh',
  'orderHistory.title': 'Lịch sử đặt lệnh',
  'orderHistory.tradeId': 'ID giao dịch',
  'orderHistory.tradingPrice': 'Giá giao dịch',
  'orderHistory.tradingTotal': 'Tổng lượng giao dịch',
  'privateKeyModal.backupText':
    'Hãy ghi lại đoạn văn bản dưới đây lên giấy và lưu trữ nó ở một nơi bí mật và an toàn.',
  'privateKeyModal.title': 'Private key của bạn',
  'testnet.binanceChainExplorerGuide': 'Hướng dẫn sử dụng trình khám phá của Binance Chain',
  'testnet.fastAndSecureDesc': 'Nền tảng giao dịch tài sản kỹ thuật số nhanh và an toàn',
  'testnet.fundingYourTestnetAccount': 'Nạp tiền cho tài khoản testnet của bạn',
  'testnet.howToAccessYourWallet': 'Cách truy cập vào ví của bạn',
  'testnet.howToCreateAWallet': 'Cách tạo ví mới',
  'testnet.interfaceGuide': 'Hướng dẫn giao diện',
  'testnet.thingsToAvoid': 'Những điều cần tránh',
  'testnet.title': 'Sàn giao dịch phi tập trung Binance (Mạng Thử Nghiệm)',
  'token.issueModal.mintable': 'Có thể tạo thêm',
  'token.issueModal.name': 'Tên token',
  'token.issueModal.nameErrMsg': 'tên token tối đa là 32 ký tự',
  'token.issueModal.symbol': 'Biểu tượng',
  'token.issueModal.symbolErrMsg': 'biểu tượng nên kết hợp chữ và số, độ dài từ 3-8 ký tự',
  'token.issueModal.title': 'Phát hành token',
  'token.issueModal.totalSupply': 'Tổng cung',
  'token.issueModal.totalSupplyErrMsg': 'số lượng cung không hợp lệ',
  'token.listModal.address': 'Địa chỉ',
  'token.listModal.confirm': 'Xác nhận',
  'token.listModal.initPrice': 'Giá ban đầu',
  'token.listModal.proposalId': 'Id đề xuất',
  'token.listModal.quoteAsset': 'Tài sản tính giá',
  'token.listModal.title': 'Niêm yết token',
  'token.listModal.tokenName': 'Tên token',
  'token.main.burn': 'Đốt',
  'token.main.freeze': 'Đóng băng',
  'token.main.issueToken': 'Phát hành token',
  'token.main.list': 'Niêm yết',
  'token.main.listSuccessmsg': 'Niêm yết thành công',
  'token.main.mint': 'Đúc',
  'token.main.proposal': 'Đề xuất',
  'token.main.submitListFirst': 'Vui lòng gửi đề xuất niêm yết trước',
  'token.main.submitSuccessmsg': 'gửi đề xuất niêm yết thành công',
  'token.main.title': 'Danh sách token của tôi',
  'token.main.unfreeze': 'Ngừng đóng băng',
  'token.proposalModal.address': 'Địa chỉ',
  'token.proposalModal.baseAsset': 'Tài sản cơ sở',
  'token.proposalModal.desc': 'Mô tả',
  'token.proposalModal.expireTime': 'Thời điểm hết hạn',
  'token.proposalModal.hours': 'Giờ',
  'token.proposalModal.initDeposit': 'Khoản nạp ban đầu',
  'token.proposalModal.initPrice': 'Giá ban đầu',
  'token.proposalModal.initPriceErr': 'Giá ban đầu không nên để trống',
  'token.proposalModal.initPriceErr2': 'giá ban đầu nên lớn hơn 0',
  'token.proposalModal.quoteAsset': 'Tài sản tính giá',
  'token.proposalModal.title': 'Đề xuất niêm yết',
  'token.proposalModal.titleErr': 'Tiêu đề đề xuất không nên để trống',
  'token.proposalModal.titleErr2': 'Tiêu đề đề xuất tối đa là 128 ký tự',
  'token.proposalModal.votingPeriod': 'Thời gian bỏ phiếu',
  'token.table.col.mintable': 'Có thể tạo thêm',
  'token.table.col.name': 'Tên',
  'token.table.col.symbol': 'Biểu tượng',
  'token.table.col.totalSupply': 'Tổng cung',
  'token.tokenModal.address': 'Địa chỉ',
  'token.tokenModal.amount': 'Số lượng',
  'token.tokenModal.available': 'Khả dụng',
  'token.tokenModal.burnTitle': 'Đốt token',
  'token.tokenModal.confirm': 'Xác nhận',
  'token.tokenModal.desc': ' ',
  'token.tokenModal.freezeTitle': 'Đóng băng token',
  'token.tokenModal.mintTitle': 'Tạo thêm token',
  'token.tokenModal.name': 'Tên',
  'token.tokenModal.unfreezeTitle': 'Ngừng đóng băng token',
  'token.warning':
    'We do not support walletconnect compatible wallets currently and for security reason, Ledger is the best choice to Issue/List/Mint/Burn Token',
  'tradeHistory.tradeHistory': 'lịch sử giao dịch',
  'transaction.here': 'ở đây',
  'transaction.notes':
    'Không phải tất cả giao dịch đều được bao gồm dưới đây. Để xem lịch sử đầy đủ, hãy tham khảo',
  'txHistory.here': 'tại đây',
  'txHistory.notEveryTransactionIsIncludedBelow':
    'Không phải tất cả giao dịch đều được hiển thị ở dưới. Để xem toàn bộ lịch sử, vui lòng xem ở đây.',
  'txHistory.title': 'Lịch sử giao dịch',
  'unlock.connectAddress.enterYourAddress': 'Nhập địa chỉ của bạn',
  'unlock.connectAddress.invalidAddress': 'Địa chỉ không hợp lệ',
  'unlock.connectAddress.viewOnlyMode': 'Nhập một địa chỉ ở chế độ chỉ xem',
  'unlock.createNewWallet': 'Tạo ví mới',
  'unlock.google.chooseWallet': 'Chọn từ các ví khả dụng của bạn:',
  'unlock.google.logIn': 'Đăng nhập',
  'unlock.google.notLoggedIn': 'Bạn chưa đăng nhập vào tài khoản Google',
  'unlock.google.signedInAs': 'Bạn đang đăng nhập với',
  'unlock.googledrive.editWallet': 'Chỉnh sửa chi tiết ví',
  'unlock.googledrive.wallets': 'Chọn một trong các ví dưới đây để tiếp tục:',
  'unlock.index.selectUnlockType': 'Chọn cách mở khoá',
  'unlock.index.title': 'Mở khoá ví của bạn',
  'unlock.keystore.enterYourWalletPass': 'Nhập mật khẩu ví của bạn',
  'unlock.keystore.paste': 'Hoặc dán nội dung của file keystore của bạn',
  'unlock.keystore.select': 'Kết nội một file ví đã được mã hoá và nhập mật khẩu của bạn',
  'unlock.keystore.upload': 'Tải lên file keystore',
  'unlock.ledger.appInstallation': 'Cài đặt ứng dụng',
  'unlock.ledger.binanceChainReady': 'Binance Chain sẵn sàng',
  'unlock.ledger.connectToLedger': 'Kết nối đến ví Ledger',
  'unlock.ledger.enterPINCode': 'Nhập mã PIN',
  'unlock.ledger.getTheApp': 'Truy cập ứng dụng',
  'unlock.ledger.havingConnectionIssues': 'Đang gặp vấn đề về kết nối?',
  'unlock.ledger.mustBeOnScreen': 'phải hiển thị trên màn hình',
  'unlock.ledger.openBinanceChain': 'Mở Binance Chain',
  'unlock.ledger.text': 'Kết nối đến ví phần cứng bằng cách làm theo các chỉ dẫn trên màn hình',
  'unlock.ledger.title': 'Mở khoá bằng thiết bị Ledger',
  'unlock.ledger.usageInstructions': 'Hướng dẫn sử dụng',
  'unlock.mnemonic.pleaseEnterYourPhrase': 'Nhập cụm từ 24 ký tự',
  'unlock.mnemonic.pleaseSeparateEachWordSpace': 'Vui lòng đặt dấu cách giữa các từ.',
  'unlock.mnemonic.warning.desc1': 'Lựa chọn này nhằm khôi phục file keystore hoặc mật khẩu đã mất',
  'unlock.mnemonic.warning.desc2': 'hoặc nhập seed từ một ứng dụng ví khác.',
  'unlock.mnemonic.warning.desc3':
    'Cảnh báo! Việc nhập seed hoặc private key lên bất kỳ website nào đều vô cùng nguy hiểm. Nếu trình duyệt của bạn đang cài tiện ích mở rộng độc hại hoặc bạn đang truy cập vào một trang phishing, tài sản của bạn có thể sẽ bị đánh cắp.',
  'unlock.privateKey.enterYourPrivateKey': 'Nhập private key của bạn (theo định dạng hex)',
  'unlock.privateKey.invalid':
    'Private key bạn đã nhập không đúng định dạng và không hợp lệ. Vui lòng thử lại.',
  'unlock.privateKey.passwordInvalid': 'Mật khẩu không hợp lệ. Vui lòng thử lại.',
  'unlock.privateKey.warning': 'Để khôi phục file keystore hoặc mật khẩu đã mất',
  'unlock.privateKey.warningQuestion':
    'Việc nhập seed hoặc private key lên bất kỳ website nào đều vô cùng nguy hiểm. Nếu trình duyệt của bạn đang cài tiện ích mở rộng độc hại hoặc bạn đang truy cập vào một trang phishing, tài sản của bạn có thể sẽ bị đánh cắp.',
  'unlock.recover.content':
    'Khôi phục khả năng truy cập vào ví bằng một cụm từ khôi phục có được ở thời điểm tạo ví',
  'unlock.recover.download.button': 'Tải xuống',
  'unlock.recover.downloadTitle': 'Tải xuống File Keystore của bạn',
  'unlock.recover.password.placeholder': 'Nhập một mật khẩu mạnh',
  'unlock.recover.submit': 'Gửi',
  'unlock.recover.title': 'Khôi phục File Keystore',
  'unlock.recover.understand.continue': 'Khôi phục File Keystore',
  'unlock.recover.word.placeholder': 'Tìm kiếm',
  'unlock.recover.wordlist.reset': 'Đặt lại',
  'unlock.recover.wordlistTitle': 'Hãy lựa chọn Cụm từ Ghi nhớ của bạn từ danh sách bên trái',
  'unlock.support.wallets': ' ',
  'unlock.temporarySessionPassword': 'Mật khẩu tạm thời',
  'unlock.thisIsNotAValidWalletFile': 'Đây không phải là file ví hợp lệ',
  'unlock.trezor.connectToTrezor': 'Kết nối đến ví Trezor',
  'unlock.trezor.firmwareNotice':
    'Lưu ý: Bảo đảm rằng bạn đã cập nhật Trezor lên phiên bản mới nhất để kết nối với Binance Chain.',
  'unlock.trezor.notOnTestNet': 'Lưu ý: Thiết bị Trezor từ giờ yêu cầu Chrome hoặc Firefox ',
  'unlock.trezor.title': 'Mở khoá bằng thiết bị Trezor',
  'unlock.unlockWalletNow': 'Mở khoá ví ngay',
  'unlock.walletConnect.notes':
    'Lưu ý: Trust Wallet và CoolWallet chưa hỗ trợ testnet Binance Chain.',
  'unlock.walletConnect.recommendedWallet': 'Các ứng dụng được hỗ trợ gồm',
  'unlock.walletConnet.getTrustWallet': 'Truy cập Trust Wallet',
  'unlock.walletConnet.qrCodeDesc1': 'Nhận mã QR ví WalletConnect',
  'unlock.walletConnet.qrCodeDesc2': 'Vẫn chưa có ứng dụng hỗ trợ ví WalletConnect?',
  'unlock.walletConnet.showWalletQrCode':
    'Kết nối đến ví di động của bạn bằng mã QR hiển thị trên màn hình',
  'unlock.walletConnet.title': 'Khuyên dùng',
  'walletConnect.clickHereToUnlock': 'Nhấn vào đây để mở khoá một ví khác',
  'walletConnect.error': 'Lỗi ví WalletConnect',
  'walletConnect.errorOccur': 'Xảy ra lỗi ví WalletConnect',
  'walletConnect.pleaseEnsureOpenWorking':
    'Hãy bảo đảm rằng ứng dụng đang mở và hoạt động bình thường.',
  'walletConnect.pleaseUseAWalletConnect':
    'Hãy sử dụng một ứng dụng hỗ trợ WalletConnect để quét mã QR ở trên',
  'walletConnect.qrCode': 'Mã QR kết nối ví WalletConnect',
  'walletConnect.readyToConfirm': 'Vui lòng xác nhận',
  'walletConnect.readyToConfirmBody': 'Vui lòng xác nhận giao dịch trên Ứng dụng ví.',
  'walletconnect.notifycation.connectAgain': 'Kết nối lại',
  'walletconnect.notifycation.disconnectMessage': ' Ngừng kết nối đến Ví di động...',
  'walletconnect.notifycation.hide': 'Ẩn',
  'local.secure.storage': 'Local Secure Storage',
  'local.keystore.replace.tips':
    'You already have a keystore file, make sure you have backed up before replace',
}
